// extracted by mini-css-extract-plugin
export var chevron = "_ji-3";
export var chevronRotated = "_ji-4";
export var image = "_ji-1";
export var imageContainer = "_ji-0";
export var shippingAddress = "_ji-2";